/**
 * Sandbox document builder for the Agent scratchpad's free-form drawings.
 *
 * STATIC SVG ONLY — the d3 code-execution mode was removed 2026-08-14
 * (Nick: the model either uses the insight harness or draws something).
 * The SVG renders inside <iframe sandbox="allow-scripts-less"> — sandbox=""
 * with no allowances: no scripts, no same-origin, null origin. Safe by
 * construction; SMIL/CSS animations inside the SVG still play.
 *
 * Lives in a plain .js file deliberately: tag-text assembly confuses the
 * Vue SFC parser when inlined in a .vue file.
 */
const HEAD = '<!doctype html><meta charset="utf-8">'
  + '<style>body{margin:0;font-family:system-ui,sans-serif;background:#fff}'
  + 'svg{max-width:100%;height:auto;display:block}</style>'

export function drawingDoc(v) {
  return HEAD + (v.svg || '')
}
